class HelpCenter extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.tabs = Array.from(this.querySelectorAll('[data-help-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-help-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.helpTab));
    });
  }

  activate(id) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.helpTab === id;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.helpPanel === id;
      panel.classList.toggle('is-hidden', !active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('help-center')) {
  customElements.define('help-center', HelpCenter);
}
